import React, { useState } from "react";
import type { DeliverySchedule } from "../../types";
import { getJstTime, getJstToday } from "../../logic/dateUtils";
import { showErrorMessage } from "../appPane";
import { MESSAGES } from "../../constants/const";
import ModalHeader from "./modalHeader";
import { getInputDateString } from "../../logic/dateUtils";

interface ActualInputModalProps {
  /** 納入予定実績情報 */
  schedule: DeliverySchedule;
  /** キャンセルボタンハンドラ */
  onClose: () => void;
  /** 登録ボタンハンドラ */
  onSubmit: (date: string, time: string, amount: number) => void;
}

/**
 * 薬剤納入実績入力ポップアップ
 * @param props
 * @returns
 */
export const ActualInputModal: React.FC<ActualInputModalProps> = ({
  schedule,
  onClose,
  onSubmit,
}) => {
  // 入力中日付
  const [date, setDate] = useState(
    schedule.resultDate?.slice(0, 10).replaceAll("/", "-") ?? getJstToday()
  );
  // 入力中時刻
  const [time, setTime] = useState(schedule.resultTime ?? getJstTime());
  // 入力中納入量
  const [volume, setVolume] = useState(
    (schedule.resultVolume ?? schedule.planVolume)?.toString() ?? ""
  );
  const today = new Date();

  // 登録ボタン押下時ハンドラ
  const sendForm = async (e: React.FormEvent) => {
    e.preventDefault();
    if (date && time && volume) {
      if (Number.isNaN(Number(volume))) {
        showErrorMessage(MESSAGES.ERROR_INPUT_INVALID);
        return;
      }
      await onSubmit(date, time, Number(volume));
    } else {
      showErrorMessage(MESSAGES.ERROR_INPUT_EMPTY);
    }
  };

  return (
    <div className="modal">
      <div className="content">
        <ModalHeader title="実績入力" onClose={onClose} />
        <p>納入予定： {schedule.chemicalName}</p>
        <form onSubmit={sendForm}>
          <div className="parts">
            <label>日付</label>
            <input
              type="date"
              value={date}
              max={getInputDateString(today)}
              onChange={e => setDate(e.target.value)}
              required
            />
          </div>
          <div className="parts">
            <label>時刻</label>
            <input type="time" value={time} onChange={e => setTime(e.target.value)} required />
          </div>
          <div className="parts">
            <label>数量</label>
            <input
              type="number"
              step="any"
              value={volume}
              onChange={e => setVolume(e.target.value)}
              min={0}
              required
            />
          </div>

          <div className="parts actions">
            <button onClick={onClose} className="negative">
              キャンセル
            </button>
            <button type="submit" className="positive">
              登録
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ActualInputModal;
